import { render, staticRenderFns } from "./f-tags.vue?vue&type=template&id=0bbe972d&functional=true&lang=pug&"
import script from "./f-tags.vue?vue&type=script&lang=js&"
export * from "./f-tags.vue?vue&type=script&lang=js&"
import style0 from "./f-tags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbe972d')) {
      api.createRecord('0bbe972d', component.options)
    } else {
      api.rerender('0bbe972d', component.options)
    }
    module.hot.accept("./f-tags.vue?vue&type=template&id=0bbe972d&functional=true&lang=pug&", function () {
      api.rerender('0bbe972d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-tags.vue"
export default component.exports